import type { fetchBlogs } from '@eliadmin/core/src/api/blogs/blogs-api';
import { CacheKey } from '@eliadmin/core/src/api/constants';

export type BlogListPage = Awaited<ReturnType<typeof fetchBlogs>>;
export const BLOG_PAGE_SIZE = 7;

// Shared by SSR and client; keep Kapycar's verified categories.equals contract.
export function blogListRequest(locale: string, page = 1, categoryId?: number) {
  return {
    locale,
    query: {
      page,
      results: BLOG_PAGE_SIZE,
      order: 'desc' as const,
      orderBy: 'created_at' as const,
      where: categoryId == null ? undefined : { categories: { equals: categoryId } },
    },
  };
}

export function blogListKey(locale: string, categoryId?: number) {
  return [CacheKey.BLOGS, 'kapycar-public-list', blogListRequest(locale, 1, categoryId)] as const;
}

export function blogListInitialData(page?: BlogListPage, categoryId?: number) {
  return categoryId == null && page ? { pages: [page], pageParams: [1] } : undefined;
}

export function nextBlogPage(lastPage: BlogListPage) {
  return lastPage?.meta?.current_page < lastPage?.meta?.last_page
    ? lastPage.meta.current_page + 1
    : undefined;
}
